import { render, staticRenderFns } from "./WeeklyEmailComposer.vue?vue&type=template&id=140f7000&"
import script from "./WeeklyEmailComposer.vue?vue&type=script&lang=js&"
export * from "./WeeklyEmailComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports